import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import {
  AccountInfo,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser'

import App from './App'
import { ProgressBarTemplate } from './components/ProgressTemplate'
import reportWebVitals from './reportWebVitals'
import { clientConfig } from './utils/auth/clientConfig'
import './utils/i18n.ts'
import '/'

export const msalInstance = new PublicClientApplication(clientConfig)

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}
// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents()
msalInstance.addEventCallback(event => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    (event.payload as AccountInfo)
  ) {
    const account = event.payload as AccountInfo
    msalInstance.setActiveAccount(account)
  }
})

const rootElement = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(rootElement)

root.render(
  // If you want to test responsive dialogs put <React.StrictMode> in a comment
  <React.StrictMode>
    <Suspense fallback={<ProgressBarTemplate />}>
      <App publicClient={msalInstance} />
    </Suspense>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
